export function getClusterMarkerSize(count: number): number {
  if (count >= 1000) {
    return 140
  }
  if (count >= 100) {
    return 120
  }
  if (count >= 10) {
    return 80
  }
  return 40
}
